import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Image } from '../../components';
import StackingCard from '../../components/CardStack/Card/StackingCard';
import CardStack from '../../components/CardStack/CardStack';
import { Settings } from '../../components/Settings/Settings';
import { useGlobalStateContext } from '../../context/GlobalStateContext/GlobalStateContext';
import { useSettingsContext } from '../../context/SettingsContext/SettingsContext';
import BackButton from '../../lib/components/BackButton';
import { useIsDesktop } from '../../utils/mediaQueries';
import styles from './styles';
export const SettingsPage = () => {
    const { t: text } = useTranslation();
    const isDesktop = useIsDesktop();
    const { settingsContextState: { formChanged } = {}, updateSettingsContextState } = useSettingsContext();
    const { updateGlobalState } = useGlobalStateContext();
    const navigate = useNavigate();
    const onBackClickHandler = () => {
        if (formChanged) {
            updateSettingsContextState({ saveChangesOpen: true, backClicked: true });
        }
        else {
            updateGlobalState({ merchantUpdated: null });
            navigate(-1);
        }
    };
    return (_jsx(Box, { children: _jsx(Grid, { container: true, direction: 'column', rowSpacing: 3, sx: styles.main, children: _jsxs(CardStack, { children: [_jsx(StackingCard, { lvl: 2, sectionName: text('SETTING_TITLE'), children: _jsxs(Box, { sx: styles.cardHeader, children: [_jsxs(Box, { sx: { flex: '1' }, children: [_jsx(BackButton, { onClick: () => onBackClickHandler(), sectionName: text('SETTING_TITLE') }), _jsx(Typography, { variant: 'h1', sx: { mt: '2rem' }, children: text('SETTING_TITLE') }), _jsx(Box, { sx: styles.bottom, children: _jsx(Box, { children: _jsx(Typography, { variant: 'subtitle1', sx: { fontSize: { mobile: '14px', desktop: '18px' } }, children: text('SETTING_SUBTITLE') }) }) })] }), _jsx(Box, { sx: styles.imageContainer, children: isDesktop && (_jsx(Image, { src: '/assets/images/settings-decoration.svg', altTextKey: 'empty' })) })] }) }), _jsx(StackingCard, { color: '#E4EEEF', sectionName: 'Setting Details', children: _jsx(Box, { sx: { minHeight: '670px' }, children: _jsx(Settings, { cancelHandler: onBackClickHandler }) }) })] }) }) }));
};
